<template>
	<section class="knd-inkomsten">
		<div class="knd-container">
			<article class='knd-container' ref='scroll'>
				<div class="knd-step" 
					v-for='(step, index) in stepper' 
					:data-topic='step.topic' 
					:data-step="step.step" 
					:key="step.topic + index"
				>
					<div class="knd-step__inner">
						<p v-html='output_text(step.content)'></p>
					</div>
				</div>
			</article>			
		</div>
	</section>

</template>

<script>

import scrollama from "scrollama";

export default {
	name: 'Thema',
	data: function() {
		return {
			first: true,
			stepper: this.$store.state.data.inkomsten.stepper
		}
	},
	components: {},
	mounted: function() {
		this.initScrollama();
	},

	computed: {
		gemeente:function(){
			return this.$store.getters.selectedGemeente;
		}	
	},

	methods: {

		initScrollama () {
			// initialize the scrollama
			var scroller = scrollama();

				// find the halfway point of the initial viewport height
				// (it changes on mobile, but by just using the initial value
				// you remove jumpiness on scroll direction change)
				var midpoint = Math.floor(window.innerHeight * 0.5) + "px";
				// 1. setup the scroller with the bare-bones options
				//    this will also initialize trigger observations
				// 2. bind scrollama event handlers (this can be chained like below)

				let steps = this.$refs.scroll.querySelectorAll('.knd-step');

				scroller
					.setup({
						step: steps,
						debug: false,
						offset: midpoint
					})
					.onStepEnter(this.handleStepEnter)
					.onStepExit(this.handleStepExit);
	
		},

		// scrollama event handlers
		handleStepEnter(response) {
			// response = { element, direction, index }

				let el = response.element;
				let topic = el.dataset.topic;
				let step = el.dataset.step;

				this.$store.dispatch('updateStep', {topic, step});

				if(this.first) {
					this.first = false;
				} 

			switch(response.index) {
				case 0:
					if(this.first) {
						this.first = false;
					} 
					break;
				case 1:
					break;
			}

			console.log(response);
			// add to color to current step
			response.element.classList.add("is-active");
		},

		handleStepExit(response) {
			// response = { element, direction, index }
			console.log(response);
			// remove color from current step
			response.element.classList.remove("is-active");
		},

		loopObject(start, prop) {
			return start[prop];
		},

		output_text(text) {
			if(!text) return;
			return text.replace(/{{([^}]*)}}/g, (match, capt) => {
				let arr = capt.split('.');
				let start = this;
				for(var i = 0; i < arr.length; i++) {
					start = this.loopObject(start, arr[i])
				}

				start = start.toString().replace(".", ",");
				return start;
			})		
		}    

	}
}
</script>